package cz.lhoracek.mapl.domain

fun isPowerOfTwo(value: Int): Boolean =
    value > 0 && (value and (value - 1)) == 0

fun normalizeBetToPowerOfTwo(value: Int): Int =
    highestPowerOfTwoAtMost(value.coerceAtLeast(1))

fun nextBetPowerOfTwo(value: Int): Int {
    val normalized = value.coerceAtLeast(1)
    if (!isPowerOfTwo(normalized)) {
        return highestPowerOfTwoAtMost(normalized) * 2
    }
    return if (normalized <= Int.MAX_VALUE / 2) normalized * 2 else normalized
}

fun previousBetPowerOfTwo(value: Int): Int {
    val normalized = value.coerceAtLeast(1)
    if (normalized == 1) return 1
    return if (isPowerOfTwo(normalized)) normalized / 2 else highestPowerOfTwoAtMost(normalized)
}

private fun highestPowerOfTwoAtMost(value: Int): Int {
    var power = 1
    while (power <= value / 2) {
        power *= 2
    }
    return power
}
